import { Component, Input, OnInit } from '@angular/core';
import { ITeaser } from '@shared/interfaces';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../current-project';

@Component({
    selector: 'app-home-card',
    templateUrl: './home-card.component.html',
    styleUrls: ['./home-card.component.scss'],
    standalone: false
})
export class HomeCardComponent implements OnInit {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Input() teaserBox: ITeaser;
    @Input() shadow = 'sm';
    cssClasses: string;

    ngOnInit() {
        this.setCssClasses();
    }

    private setCssClasses() {
        const cssClasses: Array<string> = [];
        cssClasses.push('card');
        if (this.shadow === 'md') {
            cssClasses.push('shadow');
        } else {
            cssClasses.push(`shadow-${this.shadow}`);
        }
        this.cssClasses = cssClasses.join(' ');
    }
}
